'use strict'

define [], () ->
  ($rootScope, $scope, $http, RentappService, $uibModalInstance) ->
    $scope.start_link = (type) ->
      $uibModalInstance.close(type)


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/bank_account.coffee